import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { Paginator, PaginatorModule } from 'primeng/paginator';
import { Collection, SavedVehicle } from '../../../graphql/generated/generated-types';
import { ActivatedRoute, Router } from '@angular/router';
import { IShopParams } from '../../../routes/shop/shop.component';
import { Observable } from 'rxjs';

interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [CommonModule, PaginatorModule],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',

})
export class PaginationComponent implements OnInit {

  @ViewChild('paginator', { static: true }) paginator: Paginator

  @Input() perPage: number = 26;
  @Input() currentPage: number = 0;
  @Input() totalResults: number = 0;
  @Input() collection: Collection;
  @Input() searchTerm: string;
  @Input() loading: boolean = false;

  @Input() pages: number = 10;
  @Input() first: number = 0;
  @Input() showFirstLastIcon: boolean = false;


  @Input() inShopCategoryDescription!: string;
  @Input() hideShopCategoryLabelsInMobile: boolean = false;

  @Input() inShop!: boolean;
  @Input() showLabel: boolean = false;

  @Input() activeVehicle: SavedVehicle;

  constructor(private router: Router, private route: ActivatedRoute) {

  }

  onPageChange(event: PageEvent | any) {
    this.first = event.first;
    this.currentPage = event.page;
    this.pages = event.rows;

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: event.page } as IShopParams,
      queryParamsHandling: 'merge',
      state: {
        noScroll: true,
      },
    });

  }

  ngOnInit(): void {

  }








}
